import { request } from '@/services/fetch';

export async function listChatContacts({ clinicaId }) {
  const params = new URLSearchParams();
  params.set('clinicaId', String(clinicaId || ''));
  const data = await request(`api/chat/users?${params.toString()}`, { method: 'GET' });
  const list = Array.isArray(data) ? data : (data?.data || []);
  return list.filter((c) => c.accountType === 'user');
}

